import lottie from 'lottie-web';
import { 
  initAuth,
  login,
  logout,
  deleteAccount,
  getSession,
  getToken,
  getUser
 } from '../../plugin/authService';

window.PhotoURL =
[
    {
        "id_hotel_photo": 150,
        "id_hotel": "45",
        "hotel_photo": "https://beta.pingingo.com/hotel_photos/Hotel__6666cfdb54313_1718013915_Beta.jpeg"
    },
    {
        "id_hotel_photo": 151,
        "id_hotel": "45",
        "hotel_photo": "https://beta.pingingo.com/hotel_photos/Hotel__6666cffe91955_1718013950_Beta.jpeg"
    },
    {
        "id_hotel_photo": 152,
        "id_hotel": "45",
        "hotel_photo": "https://beta.pingingo.com/hotel_photos/Hotel__6666cffe9422b_1718013950_Beta.jpeg"
    },
    {
        "id_hotel_photo": 153,
        "id_hotel": "45",
        "hotel_photo": "https://beta.pingingo.com/hotel_photos/Hotel__6666cffec9d42_1718013950_Beta.jpeg"
    },
    {
        "id_hotel_photo": 154,
        "id_hotel": "45",
        "hotel_photo": "https://beta.pingingo.com/hotel_photos/Hotel__6666cfff70bbe_1718013951_Beta.jpeg"
    },
    {
        "id_hotel_photo": 155,
        "id_hotel": "45",
        "hotel_photo": "https://beta.pingingo.com/hotel_photos/Hotel__6666cfff8742a_1718013951_Beta.jpeg"
    },
    {
        "id_hotel_photo": 156,
        "id_hotel": "45",
        "hotel_photo": "https://beta.pingingo.com/hotel_photos/Hotel__6666d0005572f_1718013952_Beta.jpeg"
    },
    {
        "id_hotel_photo": 157,
        "id_hotel": "45",
        "hotel_photo": "https://beta.pingingo.com/hotel_photos/Hotel__6666d0006ece7_1718013952_Beta.jpeg"
    },
    {
        "id_hotel_photo": 158,
        "id_hotel": "45",
        "hotel_photo": "https://beta.pingingo.com/hotel_photos/Hotel__6666d000864dd_1718013952_Beta.jpeg"
    },
    {
        "id_hotel_photo": 159,
        "id_hotel": "45",
        "hotel_photo": "https://beta.pingingo.com/hotel_photos/Hotel__6666d00126af2_1718013953_Beta.jpeg"
    },
    {
        "id_hotel_photo": 160,
        "id_hotel": "45",
        "hotel_photo": "https://beta.pingingo.com/hotel_photos/Hotel__6666d0013ea6a_1718013953_Beta.jpeg"
    },
    {
        "id_hotel_photo": 161,
        "id_hotel": "45",
        "hotel_photo": "https://beta.pingingo.com/hotel_photos/Hotel__6666d001408f2_1718013953_Beta.jpeg"
    },
    {
        "id_hotel_photo": 162,
        "id_hotel": "45",
        "hotel_photo": "https://beta.pingingo.com/hotel_photos/Hotel__6666d00155cda_1718013953_Beta.jpeg"
    },
    {
        "id_hotel_photo": 163,
        "id_hotel": "45",
        "hotel_photo": "https://beta.pingingo.com/hotel_photos/Hotel__6666d00155cc9_1718013953_Beta.jpeg"
    },
    {
        "id_hotel_photo": 164,
        "id_hotel": "45",
        "hotel_photo": "https://beta.pingingo.com/hotel_photos/Hotel__6666d00156b23_1718013953_Beta.jpeg"
    },
    {
        "id_hotel_photo": 165,
        "id_hotel": "45",
        "hotel_photo": "https://beta.pingingo.com/hotel_photos/Hotel__6666d00157aec_1718013953_Beta.jpeg"
    },
    {
        "id_hotel_photo": 166,
        "id_hotel": "45",
        "hotel_photo": "https://beta.pingingo.com/hotel_photos/Hotel__6666d00157cd0_1718013953_Beta.jpeg"
    },
    {
        "id_hotel_photo": 167,
        "id_hotel": "45",
        "hotel_photo": "https://beta.pingingo.com/hotel_photos/Hotel__6666d00158334_1718013953_Beta.jpeg"
    },
    {
        "id_hotel_photo": 168,
        "id_hotel": "45",
        "hotel_photo": "https://beta.pingingo.com/hotel_photos/Hotel__6666d00158744_1718013953_Beta.jpeg"
    },
    {
        "id_hotel_photo": 169,
        "id_hotel": "45",
        "hotel_photo": "https://beta.pingingo.com/hotel_photos/Hotel__6666d00158be2_1718013953_Beta.jpeg"
    },
    {
        "id_hotel_photo": 170,
        "id_hotel": "45",
        "hotel_photo": "https://beta.pingingo.com/hotel_photos/Hotel__6666d0015a051_1718013953_Beta.jpeg"
    },
    {
        "id_hotel_photo": 171,
        "id_hotel": "45",
        "hotel_photo": "https://beta.pingingo.com/hotel_photos/Hotel__6666d0016e890_1718013953_Beta.jpeg"
    },
    {
        "id_hotel_photo": 172,
        "id_hotel": "45",
        "hotel_photo": "https://beta.pingingo.com/hotel_photos/Hotel__6666d00170b70_1718013953_Beta.jpeg"
    },
    {
        "id_hotel_photo": 173,
        "id_hotel": "45",
        "hotel_photo": "https://beta.pingingo.com/hotel_photos/Hotel__6666d00170bf5_1718013953_Beta.jpeg"
    },
    {
        "id_hotel_photo": 174,
        "id_hotel": "45",
        "hotel_photo": "https://beta.pingingo.com/hotel_photos/Hotel__6666d00171397_1718013953_Beta.jpeg"
    },
    {
        "id_hotel_photo": 230,
        "id_hotel": "45",
        "hotel_photo": "https://beta.pingingo.com/hotel_photos/Hotel__681b233080cb6_1746608944.jpg"
    }
]


// // ======================================= RENEW IMAGE POOL ===========================================

// window.createImagePoolImmediate = function (urls)
// {
//     return urls.map(url =>
//     {
//         const img = document.createElement("img");
//         img.dataset.src = url.hotel_photo;     // keep real URL here
//         return img;
//     });
// };

// window.HotelSwiper = null;

// window.instantiateSkeletonSwiper = function(pool)
// {
//     const root = document.getElementById("SampleHotelSwiper");
//     const wrapper = root.querySelector(".swiper-wrapper");

//     window.HotelSwiper = new window.Swiper(root, {
//         slidesPerView: 1,
//         observer: true,
//         observeParents: true
//     });

//     pool.forEach(img =>
//     {
//         const skeleton = document.createElement("div");
//         skeleton.className = "loading_grey ImageFullCover";

//         const slide = document.createElement("div");
//         slide.className = "swiper-slide";
//         slide.appendChild(skeleton);

//         wrapper.appendChild(slide);

//         img._skeleton = skeleton;   // store link for later replace
//     });

//     window.HotelSwiper.update();
// };


// window.resolvePoolInBackground = async function(pool, fallback)
// {
//     for (const img of pool)
//     {
//         const realUrl = img.dataset.src;
//         const resolved = await window.resolveImageUrlForPool(realUrl, fallback, {quality:100});

//         img.onload = () =>
//         {
//             img._skeleton.replaceWith(img);   // clean replacement
//         };

//         img.src = resolved || fallback;
//     }
// };

window.PrepareTestInstantiate = function()
{
    let container = document.getElementById("container");
    // console.log(window.PhotoURL);
    // let pool = window.createImagePoolImmediate(window.PhotoURL);

    // window.instantiateSkeletonSwiper(pool);          // instant UI
    // window.resolvePoolInBackground(pool, "/Assets/images/NoHotelImage.jpg"); // background load


    window.createLottie('container', '/Assets/images/lottieanim/cross.json', {});
    
    initAuth((maindata, userinfodata) =>
    {
        console.log("MAIN DATA:", maindata);
        console.log("USER DATA:", userinfodata);
    });
    // window.TestLoadBooking();
    // window.TestLoadPopUpBanner();
};


// Test Send Email ----------------------------------------------

window.TestSendEmailTemplate = function(whattype)
{
    let IdTransactionInput = document.getElementById("IdTransactionInput").value;

    let TestSendEmailTemplate = "/v2/emails/test/waiting-payment?lang=" + window.CurrentCountryID + "&id_transaction=" + IdTransactionInput;
    if(whattype == "success")
    {
        TestSendEmailTemplate = "/v2/emails/test/success-payment?lang=" + window.CurrentCountryID + "&id_transaction=" + IdTransactionInput;
    }
    else if(whattype == "timeout")
    {
        TestSendEmailTemplate = "/v2/emails/test/timeout-payment?lang=" + window.CurrentCountryID + "&id_transaction=" + IdTransactionInput;
    }
    else if(whattype == "timeout")
    {
        TestSendEmailTemplate = "/v2/emails/test/timeout-payment?lang=" + window.CurrentCountryID + "&id_transaction=" + IdTransactionInput;
    }
    else if(whattype == "BookingConfirmed")
    {
        TestSendEmailTemplate = "/v2/emails/booking-confirmed?lang=" + window.CurrentCountryID + "&id_transaction=" + IdTransactionInput;
    }
    else if(whattype == "BookingCompleted")
    {
        TestSendEmailTemplate = "/v2/emails/booking-completed?lang=" + window.CurrentCountryID + "&id_transaction=" + IdTransactionInput;
    }
    console.log(TestSendEmailTemplate);

    window.CallApiAxios({
        method: "GET",
        url: TestSendEmailTemplate,
    }).then(res =>
    {
        console.log(res);
    })
    .catch(err =>
    {
        console.log(err);
    });
}